// extracted by mini-css-extract-plugin
module.exports = {"bio":"index-module__bio___707zo","profile_section_headline":"index-module__profile_section_headline___XuhU8","add_bio":"index-module__add_bio___ZOArR"};